import { useNavigate } from 'react-router-dom';
import styles from './BannerDiscountMessageBlock.module.scss';
import { Feather } from '@phosphor-icons/react';
import { SVG_SIZE_M } from 'src/constants';
import { AppRoutes, PlanKind } from 'src/types';
import { Button } from 'src/v2/commonComponents/Button';
import { usePaymentControlState } from 'src/hooks';

type BannerDiscountMessageBlockProps = {
  onChangeAppliedValue?: (value: string | undefined) => void;
};

export const BannerDiscountMessageBlock = ({
  onChangeAppliedValue,
}: BannerDiscountMessageBlockProps) => {
  const navigate = useNavigate();
  const couponCode = 'NinjaThanks';
  const { selectedPlan } = usePaymentControlState();

  const handleUpgradeClick = () => {
    if (selectedPlan) {
      onChangeAppliedValue?.(couponCode);
    } else {
      const url = `${AppRoutes.PAYMENT}?selected_plan=${PlanKind.MAX_10_ANNUALLY}&coupon=${couponCode}&timestamp=${Date.now()}`;
      navigate(url, { replace: true });
    }
  };

  return (
    <div className={styles.root}>
      <Feather size={SVG_SIZE_M} />
      <span>
        Save 50% off all plans, starting at $9.50 USD/month. Coupon code{' '}
        <b>{couponCode}</b>.
        <Button
          color="transparent"
          as="button"
          className={styles.upgrade}
          onClick={handleUpgradeClick}
        >
          Apply
        </Button>
      </span>
    </div>
  );
};
